/*
Access Control Mixins:
* canLogin
* userName
* userId
* loginTime
* canAccess
* isSuper
* isManager
* userRole
--------------------------------------------------
*/

import {IS_DEV, API_KEY, COOKIE} from '@/components/Data' // COOKIE,
import axios from '@/lib/axiosClient'

import MD5 from 'crypto-js/md5'

export default {

  methods: {

    xolasClient () {
      return this.getStore().xolasClient
    },

    profile () {
      return this.getStore().profile
    },

    org () {
      return this.getStore().org
    },

    showLoginStatus () {
      console.log('UserName:', this.userName(), 'Logged In: ', this.loginTime())
    },



    canLogin (user, psw) {

      if (user) {
        user = user.trim()
      } else {
        this.$message({message: 'Invalid user or email', type: 'warning', center: true})
      }

      if (psw) {
        psw = MD5(psw.trim()).toString()
      } else {
        this.$message({message: 'Invalid Password', type: 'warning', center: true})
      }

      let headers = {
        headers: {
          'Accept': 'application/json',
          'X-API-Key': API_KEY
          }
        }

      let login = {
       login: user,
       password: psw
       }

      axios.post(this.getEndpoint('/login'), login, headers)
        .then((resp) => {

            if (!this.checkWarning(resp)) {

              this.getStore().profile = resp.data
              this.getStore().org = resp.data.organisation
              this.getStore().profile.loginTime = new Date()
              this.getStore().profile.allowedHost = this.getStore().hostname
              this.getStore().isLoggedIn = true
              this.saveStore()

              this.refreshStats(this.org().id)
              this.$router.push('/')

            } else {
              this.getStore().isLoggedIn = false
              this.$message({message: resp.error, type: 'warning'})
            }

        })
        .catch((error) => {
          console.log('axios error', error)
//          this.getStore().isLoggedIn = false
          this.$message({message: error, type: 'warning', center: true})

          this.$router.push('/login')

        })

      // ----------------------------------------------------------------
/*
      if (this.canAccessHost(this.org().allowedHost)) {
        this.getStore().isLoggedIn = true

        if (this.loggedIn()) {

          var orgUrl = this.getEndpoint('org/' + this.org().id)

          axios.get(orgUrl).then(response => {

            this.getStore().organisation = response.data
            this.saveStore()

            console.log('Logged-in Organisation:', this.getStore().organisation.name)
          })
          .catch(e => {
            this.getStore().organisation = {}
            console.error('Error Loading Organisation Info: ', e)
          })


          this.saveStore()
          return true
        }
      } else {
        this.$cookies.remove(COOKIE)
        return false
      }
*/
    },


    logout () {
      let headers = {
        headers: {
          'Accept': 'application/json',
          'X-API-Key': API_KEY
          }
        }

      let out = {
       sessionId: this.profile().api_token
       }

       axios.post(this.getEndpoint('/logout', null, false, false), out, headers)
         .then((resp) => {

//             console.log('logout', resp.data)

             if (!this.checkWarning(resp)) {

              localStorage.removeItem(COOKIE)
/*
               this.getStore().logoutTime = new Date()
               this.resetStore()
               this.saveStore()
*/
             } else {

               this.$message({message: resp.error, type: 'warning', center: true})

             }

         })
         .catch((error) => {
           this.$message({message: error.error, type: 'error', center: true})
         })

      this.resetStore()
      this.saveStore()
      this.refreshBrowser()
      this.$router.push('/login')

    },



    userName () {
      return (this.profile().name ? this.profile().name : this.profile().login)
    },


    loggedIn () {

      if (this.getStore().isLoggedIn) {
        return true
      } else {
        return false
      }

    },


    userId () {
      return this.profile().login
    },



    loginTime () {
      this.getStore().loginTime = new Date()
      return this.getStore().loginTime
    },


    canChange () {
      return typeof this.profile().viewer === Boolean ? this.profile().viewer : true
    },


    access (bool, feature = null) {
      return this.canChange() && bool && (feature ? this.canAccess(feature) : true)
/*
      let b = this.canChange() && bool && (feature ? this.canAccess(feature) : true)

      if (feature) {
        console.log('access', b, feature, bool)
      }
      return b
*/
    },



    // --- is Orgs --------------------------------------------------------

    isAuthority (feature = null) {
      return this.access(this.profile().orgCategory === 'Authority', feature)
    },



    isBackhaulCo (feature = null) {
      return this.access(this.profile().orgCategory === 'Backhaul', feature)
    },



    isContractorCo (feature = null) {
      return this.access(this.profile().orgCategory === 'Contractor', feature)
    },



    isLandlordCo (feature = null) {
      return this.access(this.profile().orgCategory === 'Landlord', feature)
    },



    isInsuranceCo (feature = null) {
      return this.access(this.profile().orgCategory === 'Insurance', feature)
    },



    isTelco (feature = null) {
      return this.access(this.profile().orgCategory === 'Telco', feature)
    },



    isTowerCo (feature = null) {
      return this.access(this.profile().orgCategory === 'Tower Company', feature)
    },



    isTowerSupplierCo (feature = null) {
      return this.access(this.profile().orgCategory === 'Tower Supplier', feature)
    },



    isUtility (feature = null) {
      return this.access(this.profile().orgCategory === 'Utility', feature)
    },



    isApprover (feature = null) {
      if (this.isSuper()) {
        return true
      } else {
        return this.access(this.profile().approver, feature)
      }
    },


    // -- isXX Profile roles ----------------------------------------------

    isManager (feature = null) {
      if (this.isSuper()) {
        return true
      } else {
        return this.access(this.profile().manager, feature)
      }
    },


    isSuper () {
      if (!this.isTowerCo()) {
        return false
      } else {
        return (this.profile().super || this.profile().userRole === 'super')
      }
    },


    /*
      This is group admin view- not super user admin.
     */
    isAdminView () {
      return this.profile().defaultView === 'admin' || !this.profile().defaultView || this.isManagementView()
    },


    isBackhaulView () {
      return this.profile().defaultView === 'backhaul'
    },


    isContractorView () {
      return this.profile().defaultView === 'contractor'
    },


    isLandlordView () {
      return this.profile().defaultView === 'landlord'
    },


    isFinanceView () {
      return this.profile().defaultView === 'finance'
    },


    isTowerSupplierView () {
      return this.profile().defaultView === 'tower-suplier'
    },


    isManagementView () {
      return this.profile().defaultView === 'management' || this.isManager()
    },


    isMaintView () {
      return this.profile().defaultView === 'maintenance'
    },


    isProjectView () {
      return this.profile().defaultView === 'project'
    },


    isPropertyView () {
      return this.profile().defaultView === 'property'
    },


    isTelcoView () {
      return this.profile().defaultView === 'telco'
    },


    isViewOnly () {
      return (this.profile().viewer ? this.profile().viewer : false)
    },



    userRoles () {
      return this.profile().userRole
    },



    canAccessHost (host) {
      if (host) {

        if (IS_DEV) {
          return true
        } else {
          return host.split('|').includes(location.hostname)
        }

      } else {

        if (this.isSuper()) {
          return true
        } else {
          return false
        }

      }
    },



    canAccess (group) {

      if (this.isSuper()) {

        return true

      } else {

        if (group) {
          // TODO need to check for multiple roles in userRole
          var role = this.profile().userRole

          if (!role) {
            role = this.profile().orgCategory.toLowerCase()
          }

          if (role.includes('|')) {

            var list = role.split('|')
            var acl = new Array(list.length)


            for (var i = 0; i < list.length; i++) {
              acl[i] = group.split('|').includes(list[i])
            }

            for (i = 0; i < acl.length; i++) {
              if (acl[i]) {
                return true
              }
            }

          } else {
            return group.split('|').includes(role)
          }
        } else {
          return false
        }
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/AccessMixins.js